import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'

const NotFoundPage = ({ redirect }) => {


  return (
    <section className="not_found_section">
      {redirect && (
        <div className="container">
          <div className="row mb-50">
            <div className="col-sm-5">
              <h1 className="not_found_section_title mb-20">Página no encontrada</h1>
              <div className="not_found_section_subtitle">
                <p className="mb-50">
                  Es posible que la dirección haya cambiado o que la página ya no exista.
                </p>
                <p>
                  Puedes regresar a la página principal haciendo clic{' '}
                  <Link
                    to={`/${(redirect || '').replace(/^\//, '')}`}
                    className="redirect_link"
                  >
                    aquí
                  </Link>
                  .
                </p>
                <p className="mt-30 text-muted">
                  No te preocupes, tu sesión y datos están seguros. 🚀
                </p>
              </div>
            </div>
            <div className="col-sm-6">
              <div className="man-icon" />
            </div>
          </div>
        </div>
      )}
    </section>
  )
}

export default NotFoundPage
